import script from "./DateRange.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRange.vue?vue&type=script&setup=true&lang=js"

import "./DateRange.vue?vue&type=style&index=0&id=4a04b7f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a04b7f0"]])

export default __exports__